import { Inject, Injectable } from "@angular/core";
import { IRegistryAccountOption, IRegistryPaymentHandler } from "@zaeper/angular-registry-lib";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { StripeService } from "../stripe/stripe.service";
import { IDeveloperBillingRestClient } from "../../rest-clients/billing/i-developer-billing-rest.client";
import { developerBillingRestClientInjectionToken } from "../../rest-clients/billing/developer-billing-rest-client-injection-token";
import { ensureBillingCustomer } from "../../modals/billing-country-modal/ensure-billing-customer";

/**
 * Confirms the payment of a new registry license subscription with Stripe
 * (3D Secure if the bank asks for it), using the developer's saved
 * payment method.
 */
@Injectable()
export class RegistryStripePaymentHandler implements IRegistryPaymentHandler {
  constructor(
    private readonly _stripeService: StripeService,
    @Inject(modalServiceInjectionToken) private readonly _modalService: IModalService,
    @Inject(developerBillingRestClientInjectionToken) private readonly _billingRestClient: IDeveloperBillingRestClient
  ) {}

  async confirmSubscriptionPayment(clientSecret: string): Promise<boolean> {
    const stripe = await this._stripeService.getStripe();
    if (!stripe) {
      return false;
    }
    const { error } = await stripe.confirmCardPayment(clientSecret);
    return !error;
  }

  /** The personal account's customer is the developer's own one; an organization's comes with the company. */
  async ensureBillingCustomer(account: IRegistryAccountOption): Promise<boolean> {
    return account.kind !== "personal" || ensureBillingCustomer(this._modalService, this._billingRestClient);
  }
}
